import { action } from 'typesafe-actions';
import {
  TIPSTER_FAILURE,
  TIPSTER_REQUEST,
  TIPSTER_SUCCESS,
} from '../../constants/tipster';

export const tipsterRequestAction = (id: string) => action(TIPSTER_REQUEST, id);
export const tipsterSuccessAction = (data: any) =>
  action(TIPSTER_SUCCESS, data);
export const tipsterFailureAction = (e: any) => action(TIPSTER_FAILURE, e);

export const tipsterActions = {
  tipsterRequestAction,
  tipsterSuccessAction,
  tipsterFailureAction,
};
